import React, { useState, useEffect } from 'react'
import { Card, Image,Badge } from 'react-bootstrap'
import LocationCityIcon from '@material-ui/icons/LocationCity';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import DescriptionIcon from '@material-ui/icons/Description';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import Skeleton from '@material-ui/lab/Skeleton';
import Aos from 'aos'
import 'aos/dist/aos.css'

export const Education = ({ image, institute, university, start, end, address, aggregate, type, current, major, level }) => {

    const date = new Date();
    const pursuing = end > date.getFullYear()
    const [loaded, setLoaded] = useState(false)
    useEffect(()=>{
        Aos.init({})
    },[])

    return (
        <>
            <Card data-aos='zoom-in' style={{border:"none", borderRadius:"1rem", alignItems:'center', height:'100%', width:'100%' }} sm={12} className='mx-auto p-0' id='card-edu' >
                <Card.Body className='border' style={{ borderRadius:"1rem" }}>
                    <>
                    {!loaded 
                    ?
                    <>
                    <Skeleton className='mb-5 mx-auto' animation="wave" width={120} height={120} style={{ color:"rgba(255,255,255,.70)", backgroundColor:"rgba(255,255,255,.70)" }} variant="circle" /> 
                    <img src={image} onLoad={() => setLoaded(true)} style={{ display:"none" }} />
                    </>
                    :<Image className='border-0 mx-auto mb-3' roundedCircle src={image} style={{ width:'20vh' }}/>
                    }
                    </>
                    <Card.Title style={{ alignItems:'center', textAlign:'left' }}>
                        <LocationCityIcon style={{ marginRight:"1rem" }}/>
                        {institute}
                    </Card.Title>
                    <Card.Text style={{ textAlign:'left' }}>
                        <LocationOnIcon style={{ marginRight:"1rem" }}/>
                        {address}
                    </Card.Text>  
                    <Card.Text style={{ textAlign:'left' }}>
                        {type==='college' ? <b>University : </b> : <b>Board : </b>}
                        {university}
                    </Card.Text>  
                    <Card.Text style={{ textAlign:'left' }}>
                        <ImportContactsIcon style={{ marginRight:"1rem" }}/>
                        {type==='college' ? `Majoring in : ${major}` : level==='Higher School Certificate'  ? `Stream : ${major}` : 'Marticulation 10th level'}
                    </Card.Text>  
                    <Card.Text style={{ textAlign:'left' }}>
                        <ShowChartIcon style={{ marginRight:"1rem" }}/>
                        {pursuing ? `Pursuing ${current}` : `Achieved ${level}`}
                    </Card.Text>
                    <Card.Text style={{ textAlign:'left' }}>
                        <DescriptionIcon style={{ marginRight:"1rem" }}/>
                        {pursuing ? `CGPA so far ${aggregate}` : level==='Higher School Certificate' ? `Percentage ${aggregate}` : `CGPA ${aggregate}`}
                    </Card.Text>
                    <Card.Text style={{ textAlign:'left' }}>
                        <CalendarTodayIcon style={{ marginRight:"1rem" }}/>
                        {pursuing ? `${start}-${end}*` : `${start}-${end}`}
                    </Card.Text>
                    <Card.Text style={{ textAlign:'left' }}>
                        <h4>{pursuing ? <Badge variant='warning'>Pursuing</Badge> : <Badge style={{ color:"black" }} variant='success'>Completed</Badge>}</h4>
                    </Card.Text>
                </Card.Body>
            </Card>
        </>
    )
}
